import {
  Body2,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading2,
  Heading5,
  Icon,
  IconVariant,
  Space,
} from '@gousto-internal/citrus-react';
import { PersonOptionButton } from './layout';

function personLabel(numberOfPortions: number): { title: string; subtitle: string } {
  const lowerBound = Math.max(1, numberOfPortions - 1);
  return {
    title: `${numberOfPortions} person box`,
    subtitle: `Suitable for ${lowerBound}–${numberOfPortions} people`,
  };
}

type Props = {
  value: number;
  options: number[];
  onChange: (people: number) => void;
};

export function PeopleSelector({ value, options, onChange }: Props) {
  return (
    <Box>
      <Heading2 id="peopleSelectorLabel">Select number of people</Heading2>
      <Space size={3} />
      <Box
        role="group"
        aria-labelledby="peopleSelectorLabel"
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
        gap={4}
      >
        {options.map((people) => {
          const selected = people === value;
          const { title, subtitle } = personLabel(people);

          return (
            <PersonOptionButton
              key={people}
              type="button"
              aria-pressed={selected}
              data-selected={selected}
              onClick={() => onChange(people)}
            >
              <Icon name="people_alt_rounded" variant={IconVariant.Inherit} aria-hidden="true" />
              <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
                <Heading5 color={Color.Inherit}>{title}</Heading5>
                <Body2 color={Color.Inherit}>{subtitle}</Body2>
              </Box>
            </PersonOptionButton>
          );
        })}
      </Box>
    </Box>
  );
}
